import { anElementInstance, aSection, SectionState } from '../model';
import aboutImage from './category_images/about.file.svg';
import aboutSectionImage from './category_images/about_section.file.svg';
import bannerImage from './category_images/banner.file.svg';
import benefitsSectionImage from './category_images/benefits_section.file.svg';
import blogImage from './category_images/blog.file.svg';
import blogListHeaderSectionImage from './category_images/blog_header_section.file.svg';
import blogListSectionImage from './category_images/blog_list_sections.file.svg';
import blogPostHeaderSectionImage from './category_images/blog_post.file.svg';
import jobListingsSectionImage from './category_images/career_section.file.svg';
import contactImage from './category_images/contact.file.svg';
import contactSectionImage from './category_images/contact_section.file.svg';
import ctaSectionImage from './category_images/cta_section.file.svg';
import faqSectionImage from './category_images/faq_section.file.svg';
import featuresListSectionImage from './category_images/feature_list_section.file.svg';
import featureSectionImage from './category_images/feature_section.file.svg';
import footerImage from './category_images/footer.file.svg';
import gallerySectionImage from './category_images/gallery_section.file.svg';
import headerSectionImage from './category_images/header_section.file.svg';
import heroHeaderSectionImage from './category_images/hero_header_section.file.svg';
import homeImage from './category_images/home.file.svg';
import howItWorksSectionImage from './category_images/how_it_works_section.file.svg';
import legalImage from './category_images/legal.file.svg';
import logoSectionImage from './category_images/logo_section.file.svg';
import longFormContentSectionImage from './category_images/long_form_content_section.file.svg';
import navbarImage from './category_images/navbar.file.svg';
import portfolioImage from './category_images/portfolio.file.svg';
import portfolioItemHeaderSectionImage from './category_images/portfolio_item_header_section.file.svg';
import portfolioListSectionImage from './category_images/portfolio_section.file.svg';
import pricingImage from './category_images/pricing.file.svg';
import pricingSectionImage from './category_images/pricing_section.file.svg';
import ecommerceProductHeaderSectionImage from './category_images/product_header_section.file.svg';
import ecommerceProductListSectionImage from './category_images/product_list_section.file.svg';
import teamSectionImage from './category_images/team_section.file.svg';
import testimonialSectionImage from './category_images/testimonial_section.file.svg';

export function stripTrailingNumber(name: string) {
  return name.replace(/[0-9]+$/, '').trim();
}

export type SectionCategory = {
  name: string;
  description?: string;
  image: string;
  useGlobalInSitemapAddPanel?: boolean;
};

/* Removes common prefixes / suffixes that make the buttons too long */
export function sectionNameToButtonLabel(name: string) {
  return name
    .replace(/ Section$/, '')
    .replace(/^Ecommerce /, '')
    .replace(/^Featured Blog /, 'Blog ');
}

export const SECTION_CATEGORIES: readonly SectionCategory[] = [
  {
    name: 'Navbar',
    image: navbarImage,
    useGlobalInSitemapAddPanel: true,
  },
  {
    name: 'Footer',
    image: footerImage,
    useGlobalInSitemapAddPanel: true,
  },
  {
    name: 'Hero Header Section',
    description: 'Describe the product or service',
    image: heroHeaderSectionImage,
  },
  {
    name: 'Header Section',
    description: 'Introduce the theme of the page',
    image: headerSectionImage,
  },
  {
    name: 'Feature Section',
    description: 'Describe a feature and its benefits',
    image: featureSectionImage,
  },
  {
    name: 'Features List Section',
    description: 'Highlight a list of features and benefits',
    image: featuresListSectionImage,
  },
  {
    name: 'How It Works Section',
    description: 'Describe how the product or service works',
    image: howItWorksSectionImage,
  },
  {
    name: 'Benefits Section',
    description: 'Highlight the benefits of using the product or service',
    image: benefitsSectionImage,
  },
  {
    name: 'About Section',
    description: 'Provide information about the company',
    image: aboutSectionImage,
  },
  {
    name: 'CTA Section',
    description:
      'Invite visitors to inquire about or purchase the product or service',
    image: ctaSectionImage,
  },
  {
    name: 'Contact Section',
    description: 'Encourage visitors to contact company',
    image: contactSectionImage,
  },
  {
    name: 'Pricing Section',
    description: 'Show pricing plans for the product or service',
    image: pricingSectionImage,
  },
  {
    name: 'Testimonial Section',
    description: 'Share customer testimonials',
    image: testimonialSectionImage,
  },
  {
    name: 'FAQ Section',
    description: 'Answer frequently asked questions',
    image: faqSectionImage,
  },
  {
    name: 'Logo List Section',
    description: 'Show logos of key customers or partners',
    image: logoSectionImage,
  },
  {
    name: 'Gallery Section',
    description: 'Display gallery of images relating to the provide or service',
    image: gallerySectionImage,
  },
  {
    name: 'Team Section',
    description: 'Introduce the team behind the company',
    image: teamSectionImage,
  },
  {
    name: 'Job Listings Section',
    description: 'Provide overview of open positions',
    image: jobListingsSectionImage,
  },
  {
    name: 'Featured Blog List Header Section',
    description: 'Introduce the Blog with a featured list of Blog Posts',
    image: blogListHeaderSectionImage,
  },
  {
    name: 'Blog List Section',
    description: 'Showcase a list of Blog Posts',
    image: blogListSectionImage,
  },
  {
    name: 'Blog Post Header Section',
    description: 'Introduce the Blog Post with a title, date and description',
    image: blogPostHeaderSectionImage,
  },
  {
    name: 'Blog Post Body Section',
    description: 'Showcase the content of the Blog Post',
    image: longFormContentSectionImage,
  },
  {
    name: 'Portfolio List Section',
    description: 'Showcase a list of Portoflio Items',
    image: portfolioListSectionImage,
  },
  {
    name: 'Portfolio Item Header Section',
    description:
      'Introduce the Portfolio Item with a title, date and description',
    image: portfolioItemHeaderSectionImage,
  },
  {
    name: 'Portfolio Item Body Section',
    description: 'Showcase the content of the Portfolio Item',
    image: longFormContentSectionImage,
  },
  {
    name: 'Ecommerce Products List Section',
    description: 'Display list of products',
    image: ecommerceProductListSectionImage,
  },
  {
    name: 'Ecommerce Product Header Section',
    description: 'Introduce and share information about the product',
    image: ecommerceProductHeaderSectionImage,
  },
  {
    name: 'Announcement Banner',
    description: 'Show timely information or offers',
    image: bannerImage,
  },
];

export function aSectionElement(slug: string): SectionState['element'] {
  return { current: anElementInstance({ source: { slug } }) };
}

export type PageTemplateCategory = {
  name: string;
  vectorUrl: string;
  pages: PageTemplate[];
};
export type PageTemplate = {
  name: string;
  thumbnailUrl?: string;
  sections: readonly SectionState[];
};

export const PAGE_TEMPLATES: PageTemplateCategory[] = [
  {
    name: 'Home',
    vectorUrl: homeImage,
    pages: [
      {
        name: 'Home 1',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f68143fefc3cab0accac_home1.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar11_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe the product or service',
            element: aSectionElement('section_header1'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key customers',
            element: aSectionElement('section_logo3'),
          }),
          aSection({
            name: 'How It Works Section',
            description: 'Describe how the product or service works',
            element: aSectionElement('section_layout238'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe main feature and its benefits',
            element: aSectionElement('section_layout141'),
          }),
          aSection({
            name: 'Features List Section',
            description: 'Describe other features and their benefits',
            element: aSectionElement('section_layout225'),
          }),
          aSection({
            name: 'Results Section',
            description: 'Highlight customer results',
            element: aSectionElement('section_layout27'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share customer testimonials',
            element: aSectionElement('section_testimonial1'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product or service',
            element: aSectionElement('section_cta25'),
          }),
          aSection({
            name: 'FAQ Section',
            description: 'Answer frequently asked questions',
            element: aSectionElement('section_faq1'),
          }),
          aSection({
            name: 'Blog List Section',
            description: 'Share resources that create value for customers',
            element: aSectionElement('section_blog34'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer6_component'),
          }),
        ],
      },
      {
        name: 'Home 2',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f6793340377dbc464f8c_home2.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar3_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe the product or service',
            element: aSectionElement('section_header26'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key customers',
            element: aSectionElement('section_logo3'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe a feature and its benefits',
            element: aSectionElement('section_layout18'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe a feature and its benefits',
            element: aSectionElement('section_layout209'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe a feature and its benefits',
            element: aSectionElement('section_layout18'),
          }),
          aSection({
            name: 'Customer Section',
            description: 'Describe who the product or service is for',
            element: aSectionElement('section_layout239'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share customer testimonials',
            element: aSectionElement('section_testimonial19'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product',
            element: aSectionElement('section_cta25'),
          }),
          aSection({
            name: 'FAQ Section',
            description: 'Answer frequently asked questions',
            element: aSectionElement('section_faq4'),
          }),
          aSection({
            name: 'Blog List Section',
            description: 'Share resources that create value for customers',
            element: aSectionElement('section_blog33'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer5_component'),
          }),
        ],
      },
      {
        name: 'Home 3',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae325de671b6e72638a07_home3.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar2_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe the product or service',
            element: aSectionElement('section_header2'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key customers',
            element: aSectionElement('section_logo3'),
          }),
          aSection({
            name: 'Benefits Section',
            description:
              'Highlight the key benefits of using the product or service',
            element: aSectionElement('section_layout242'),
          }),
          aSection({
            name: 'How It Works Section',
            description: 'Describe how the product or service works',
            element: aSectionElement('section_layout121'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe a feature and its benefits',
            element: aSectionElement('section_layout210'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share a customer testimonial',
            element: aSectionElement('section_testimonial4'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe a feature and its benefits',
            element: aSectionElement('section_layout1'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share a customer testimonial',
            element: aSectionElement('section_testimonial6'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product',
            element: aSectionElement('section_cta26'),
          }),
          aSection({
            name: 'FAQ Section',
            description: 'Answer frequently asked questions',
            element: aSectionElement('section_faq6'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer4_component'),
          }),
        ],
      },
      {
        name: 'Home 4',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f6687186c60f46f96df8_home4.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar10_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe the product or service',
            element: aSectionElement('section_header73'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key customers',
            element: aSectionElement('section_logo2'),
          }),
          aSection({
            name: 'Benefits Section',
            description:
              'Highlight the key benefits of using the product or service',
            element: aSectionElement('section_layout28'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe the features of the product or service',
            element: aSectionElement('section_layout250'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share customer testimonials',
            element: aSectionElement('section_testimonial31'),
          }),
          aSection({
            name: 'Pricing Section',
            description:
              'Show the pricing for the product or service with a call to action',
            element: aSectionElement('section_pricing20'),
          }),
          aSection({
            name: 'Case Study List Section',
            description: 'Share customer success stories',
            element: aSectionElement('section_blog44'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer2_component'),
          }),
        ],
      },
      {
        name: 'Home 5',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f65f64ee2e1cc0a8656a_home5.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar5_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe the product or service',
            element: aSectionElement('section_header28'),
          }),
          aSection({
            name: 'Benefits Section',
            description:
              'Highlight the key benefits of using the product or service',
            element: aSectionElement('section_layout192'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe a feature and its benefits',
            element: aSectionElement('section_layout2'),
          }),
          aSection({
            name: 'Feature Section',
            description: 'Describe a feature and its benefits',
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share customer testimonials',
            element: aSectionElement('section_testimonial15'),
          }),
          aSection({
            name: 'Pricing Section',
            description:
              'Show the pricing for the product or service with a call to action',
            element: aSectionElement('section_pricing5'),
          }),
          aSection({
            name: 'FAQ Section',
            description: 'Answer frequently asked questions',
            element: aSectionElement('section_faq13'),
          }),
          aSection({
            name: 'Results Section',
            description: 'Highlight customer results',
            element: aSectionElement('section_layout84'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product or service',
            element: aSectionElement('section_cta1'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Home 6',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae356bd5fa5bad28e878e_home6.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar11_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe the product or service',
            element: aSectionElement('section_header15'),
          }),
          aSection({
            name: 'Feature Section',
            description:
              'Describe how a feature works and how it benefits the customer',
            element: aSectionElement('section_layout10'),
          }),
          aSection({
            name: 'Feature Section',
            description:
              'Describe how a feature works and how it benefits the customer',
            element: aSectionElement('section_layout10'),
          }),
          aSection({
            name: 'Feature Section',
            description:
              'Call out other valuable features of the product or service',
            element: aSectionElement('section_layout249'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share customer testimonials',
            element: aSectionElement('section_testimonial5'),
          }),
          aSection({
            name: 'FAQ Section',
            description: 'Answer frequently asked questions',
            element: aSectionElement('section_cta7'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product or service',
            element: aSectionElement('section_faq9'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer6_component'),
          }),
        ],
      },
      {
        name: 'Home 7',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f6491004c5df7d2818c9_home7.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar2_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe the product or service',
            element: aSectionElement('section_header9'),
          }),
          aSection({
            name: 'Contact Section',
            description:
              'List the businesses key details like opening hours, location and contact details',
            element: aSectionElement('section_layout234'),
          }),
          aSection({
            name: 'About Section',
            description:
              'Describe what makes the business unique from competitors',
            element: aSectionElement('section_layout3'),
          }),
          aSection({
            name: 'Gallery Section',
            description: 'Share images relevant to the business',
            element: aSectionElement('section_gallery10'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to inquire',
            element: aSectionElement('section_cta1'),
          }),
          aSection({
            name: 'Blog List Section',
            description: 'Share recent activity and events',
            element: aSectionElement('section_blog38'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer3_component'),
          }),
        ],
      },
      {
        name: 'Home 8',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f63c762a0d26bd162e23_home8.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar9_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe the company does',
            element: aSectionElement('section_header5'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key clients',
            element: aSectionElement('section_logo1'),
          }),
          aSection({
            name: 'About Section',
            description:
              'Describe what makes the company unique from competitors',
            element: aSectionElement('section_layout16'),
          }),
          aSection({
            name: 'Services Section',
            description: 'Describe the company\u2019s service offerings',
            element: aSectionElement('section_layout253'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share client testimonials',
            element: aSectionElement('section_testimonial16'),
          }),
          aSection({
            name: 'Blog Section',
            description: 'Resources that create value for visitors',
            element: aSectionElement('section_blog49'),
          }),
          aSection({
            name: 'FAQ Section',
            description: 'Answer frequently asked questions',
            element: aSectionElement('section_faq10'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
    ],
  },
  {
    name: 'About',
    vectorUrl: aboutImage,
    pages: [
      {
        name: 'About 1',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae17a3596ceba9bb81943_about1.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Header Section',
            description: 'Describe why the company exists',
            element: aSectionElement('section_header64'),
          }),
          aSection({
            name: 'About Section',
            description: 'Share the origin story of the company',
            element: aSectionElement('section_header15'),
          }),
          aSection({
            name: 'Results Section',
            description: 'Highlight key achievements by the company',
            element: aSectionElement('section_layout25'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key customers & partners',
            element: aSectionElement('section_logo1'),
          }),
          aSection({
            name: 'About Section',
            description: 'Share a list of company values',
            element: aSectionElement('section_layout237'),
          }),
          aSection({
            name: 'Team Section',
            description: 'Introduce the team behind the company',
            element: aSectionElement('section_team1'),
          }),
          aSection({
            name: 'Press List Section',
            description: 'Showcase a list of Press Articles about the company',
            element: aSectionElement('section_blog34'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'About 2',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae4aec89c3ff36a5715a0_about2.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Hero Header Section',
            description: 'Describe why the company exists',
            element: aSectionElement('section_header26'),
          }),
          aSection({
            name: 'Timeline Section',
            description: 'Share the story of the company through a timeline',
            element: aSectionElement('section_layout121'),
          }),
          aSection({
            name: 'About Section',
            description: 'Share the company vision',
            element: aSectionElement('section_layout140'),
          }),
          aSection({
            name: 'About Section',
            description: 'Share a list of company values',
            element: aSectionElement('section_layout241'),
          }),
          aSection({
            name: 'Team Section',
            description: 'Introduce the team behind the company',
            element: aSectionElement('section_team8'),
          }),
          aSection({
            name: 'Case Study List Section',
            description: 'Share customer success stories',
            element: aSectionElement('section_testimonial29'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'About 3',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae1a03596ce3f24b819c9_about3.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Header Section',
            description: 'Describe what the company does',
            element: aSectionElement('section_header49'),
          }),
          aSection({
            name: 'Results Section',
            description: 'Highlight key achievements by the company',
            element: aSectionElement('section_layout25'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share customer testimonials',
            element: aSectionElement('section_testimonial18'),
          }),
          aSection({
            name: 'About Section',
            description: 'Share a list of company values',
            element: aSectionElement('section_layout29'),
          }),
          aSection({
            name: 'Team Section',
            description: 'Introduce the team behind the company',
            element: aSectionElement('section_team16'),
          }),
          aSection({
            name: 'Press List Section',
            description: 'Showcase a list of Press Articles about the company',
            element: aSectionElement('section_blog46'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'About 4',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae1ac0cfcccf47a2d3528_about4.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar11_component'),
          }),
          aSection({
            name: 'Header Section',
            description: 'Describe what the company does',
            element: aSectionElement('section_header46'),
          }),
          aSection({
            name: 'Results Section',
            description: 'Highlight key achievements by the company',
            element: aSectionElement('section_layout118'),
          }),
          aSection({
            name: 'About Section',
            description: 'Share a list of company values',
            element: aSectionElement('section_layout241'),
          }),
          aSection({
            name: 'Team Section',
            description: 'Introduce the team behind the company',
            element: aSectionElement('section_team4'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key partners',
            element: aSectionElement('section_logo4'),
          }),
          aSection({
            name: 'Newsletter Section',
            description:
              "Invite visitors to sign up to the company's newsletter",
            element: aSectionElement('section_cta8'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer3_component'),
          }),
        ],
      },
      {
        name: 'About 5',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae4c1d760697e26bc3ba9_about5.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Header Section',
            description: 'Describe what makes the company unique',
            element: aSectionElement('section_header69'),
          }),
          aSection({
            name: 'About Section',
            description: 'Describe what the company does and why it exists',
            element: aSectionElement('section_layout1'),
          }),
          aSection({
            name: 'Team Section',
            description: 'Introduce the team behind the company',
            element: aSectionElement('section_team9'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share customer testimonials',
            element: aSectionElement('section_testimonial4'),
          }),
          aSection({
            name: 'Locations Section',
            description: 'Show where the company is located',
            element: aSectionElement('section_contact30'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
    ],
  },
  {
    name: 'Pricing',
    vectorUrl: pricingImage,
    pages: [
      {
        name: 'Pricing 1',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f53aeddd7ace076d2ecd_pricing1.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Pricing Section',
            description: 'Show pricing plans for the product or service',
            element: aSectionElement('section_pricing23'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share customer testimonials',
            element: aSectionElement('section_testimonial3'),
          }),
          aSection({
            name: 'Pricing Comparison Section',
            description: 'Show a comparison table of the pricing plans',
            element: aSectionElement('section_pricing21'),
          }),
          aSection({
            name: 'FAQ Section',
            description:
              'Answer frequently asked questions about pricing plans',
            element: aSectionElement('section_faq1'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product or service',
            element: aSectionElement('section_cta25'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Pricing 2',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae40608bda14013da8683_pricing2.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Pricing Section',
            description: 'Show pricing plans for the product or service',
            element: aSectionElement('section_pricing20'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key customers',
            element: aSectionElement('section_logo3'),
          }),
          aSection({
            name: 'Features List Section',
            description: 'Highlight a list of features and benefits',
            element: aSectionElement('section_layout238'),
          }),
          aSection({
            name: 'FAQ Section',
            description:
              'Answer frequently asked questions about pricing plans',
            element: aSectionElement('section_faq4'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Pricing 3',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f54f2fda69b044531f60_pricing3.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Pricing Section',
            description: 'Show pricing plans for the product or service',
            element: aSectionElement('section_pricing17'),
          }),
          aSection({
            name: 'FAQ Section',
            description:
              'Answer frequently asked questions about pricing plans',
            element: aSectionElement('section_faq12'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Share client testimonials',
            element: aSectionElement('section_testimonial11'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product or service',
            element: aSectionElement('section_cta1'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Pricing 4',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae41dc3b777cbb33d0118_pricing4.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Header Section',
            description: 'Introduce the pricing plans',
            element: aSectionElement('section_pricing19'),
          }),
          aSection({
            name: 'Pricing Section',
            description: 'Show pricing plans for the product or service',
            element: aSectionElement('section_pricing22'),
          }),
          aSection({
            name: 'Pricing Comparison Section',
            description: 'Show a comparison table of the pricing plans',
            element: aSectionElement('section_faq10'),
          }),
          aSection({
            name: 'FAQ Section',
            description:
              'Answer frequently asked questions about pricing plans',
            element: aSectionElement('section_cta25'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product or service',
            element: aSectionElement('section_logo1'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Pricing 5',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f56133403751cc463c4d_pricing5.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Header Section',
            description: 'Introduce the pricing plans',
            element: aSectionElement('section_header46'),
          }),
          aSection({
            name: 'Pricing Section',
            description: 'Show pricing plans for the product or service',
            element: aSectionElement('section_pricing19'),
          }),
          aSection({
            name: 'Logo Section',
            description: 'Show logos of key customers',
            element: aSectionElement('section_logo2'),
          }),
          aSection({
            name: 'Features List Section',
            description: 'Highlight a list of features and benefits',
            element: aSectionElement('section_layout231'),
          }),
          aSection({
            name: 'FAQ Section',
            description:
              'Answer frequently asked questions about pricing plans',
            element: aSectionElement('section_faq3'),
          }),
          aSection({
            name: 'CTA Section',
            description: 'Invite visitor to try the product or service',
            element: aSectionElement('section_cta7'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
    ],
  },
  {
    name: 'Contact',
    vectorUrl: contactImage,
    pages: [
      {
        name: 'Contact 1',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae29f7c8c09d2468dc376_contact1.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Contact Form Section',
            description:
              'Share contact details and encourage visitors to get in touch through a contact form',
            element: aSectionElement('section_contact6'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Contact 2',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae2afbd5fa5090b8e8513_contact2.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Contact Section',
            description:
              'Share contact details relating to the sales team, support team and media team',
            element: aSectionElement('section_layout228'),
          }),
          aSection({
            name: 'Details Section',
            description: 'Share email for general enquiries',
            element: aSectionElement('section_contact26'),
          }),
          aSection({
            name: 'Locations Section',
            description: 'Show where the company is located',
            element: aSectionElement('section_layout132'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Contact 3',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae2cdb54beba6e5dacd63_contact3.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Contact Form Section',
            description:
              'Encourage visitors to get in touch through a contact form',
            element: aSectionElement('section_contact7'),
          }),
          aSection({
            name: 'Contact Section',
            description: 'Share other ways visitors can get in touch',
            element: aSectionElement('section_contact17'),
          }),
          aSection({
            name: 'Locations Section',
            description: 'Show where the company is located',
            element: aSectionElement('section_contact29'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
    ],
  },
  {
    name: 'Blog',
    vectorUrl: blogImage,
    pages: [
      {
        name: 'Blog 1',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae247d760696257bc25ae_blog1.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Blog List Header Section',
            description:
              'Introduce the Blog with a featured list of Blog Posts',
            element: aSectionElement('section_blog1'),
          }),
          aSection({
            name: 'Newsletter Section',
            description:
              "Invite visitors to sign up to the company's newsletter",
            element: aSectionElement('section_cta26'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Blog 3',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624adfce3d6ba9409380aa58_624abbc5622ec83c7ffc6ca4_blog3.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Blog List Header Section',
            description:
              'Introduce the Blog with a featured list of Blog Posts',
            element: aSectionElement('section_blog10'),
          }),
          aSection({
            name: 'Newsletter Section',
            description:
              "Invite visitors to sign up to the company's newsletter",
            element: aSectionElement('section_cta8'),
          }),
          aSection({
            name: 'Blog List Section',
            description: 'Showcase a list of Blog Posts relating to a category',
            element: aSectionElement('section_blog38'),
          }),
          aSection({
            name: 'Blog List Section',
            description: 'Showcase a list of Blog Posts relating to a category',
            element: aSectionElement('section_blog38'),
          }),
          aSection({
            name: 'Blog List Section',
            description: 'Showcase a list of Blog Posts relating to a category',
            element: aSectionElement('section_blog42'),
          }),
          aSection({
            name: 'CTA Section',
            description:
              'Invite visitors to inquire about or purchase the product or service',
            element: aSectionElement('section_cta1'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Blog 4',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624adfcc382ca12f5ecf004a_624abbdb6f9fd55838e842a8_blog4.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Blog List Header Section',
            description:
              'Introduce the Blog with a featured list of Blog Posts',
            element: aSectionElement('section_blog21'),
          }),
          aSection({
            name: 'CTA Section',
            description:
              'Invite visitors to inquire about or purchase the product or service',
            element: aSectionElement('section_cta1'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
      {
        name: 'Blog 5',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae27f262b41331b78d3a0_blog5.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Blog List Header Section',
            description:
              'Introduce the Blog with a featured list of Blog Posts',
            element: aSectionElement('section_blog18'),
          }),
          aSection({
            name: 'Newsletter Section',
            description:
              "Invite visitors to sign up to the company's newsletter",
            element: aSectionElement('section_cta7'),
          }),
          aSection({
            name: 'Blog List Section',
            description: 'Showcase a list of the latest Blog Posts',
            element: aSectionElement('section_blog62'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
    ],
  },
  {
    name: 'Blog Post',
    vectorUrl: blogImage,
    pages: [
      {
        name: 'Blog Post 1',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/624ae1d8e2432b5f7c832096_blog-post1.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Blog Post Header Section',
            description:
              'Introduce the Blog Post with a title, date and description',
            element: aSectionElement('section_blog-post-header1'),
          }),
          aSection({
            name: 'Blog Post Body Section',
            description: 'Blog Post content',
            element: aSectionElement('section_content29'),
          }),
          aSection({
            name: 'Newsletter Section',
            description:
              "Invite visitors to sign up to the company's newsletter",
            element: aSectionElement('section_cta26'),
          }),
          aSection({
            name: 'Blog List Section',
            description: 'Showcase a list of related Blog Posts',
            element: aSectionElement('section_blog33'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
    ],
  },
  {
    name: 'Portfolio',
    vectorUrl: portfolioImage,
    pages: [
      {
        name: 'Portfolio 1',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6407f4b37968d414f87d1565_1.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar16_component'),
          }),
          aSection({
            name: 'Portfolio Item Header Section',
            description:
              'Introduce the Portfolio Item with a title, date and description',
            element: aSectionElement('section_portfolio-header6'),
          }),
          aSection({
            name: 'Portfolio Item Body Section',
            description: 'Summary of the opportunity',
            element: aSectionElement('section_content1'),
          }),
          aSection({
            name: 'Portfolio Item Body Section',
            description: 'Summary of the process',
            element: aSectionElement('section_content2'),
          }),
          aSection({
            name: 'Portfolio Item Body Section',
            description: 'Summary of the outcome',
            element: aSectionElement('section_gallery1'),
          }),
          aSection({
            name: 'Gallery Section',
            description: 'Showcase images of the Portfolio Item',
            element: aSectionElement('section_gallery2'),
          }),
          aSection({
            name: 'Testimonial Section',
            description: 'Testimonial from the client',
            element: aSectionElement('section_testimonial1'),
          }),
          aSection({
            name: 'Portfolio List Section',
            description: 'Showcase a list of other Portoflio Items',
            element: aSectionElement('section_portfolio2'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer9_component'),
          }),
        ],
      },
    ],
  },
  {
    name: 'Legal',
    vectorUrl: legalImage,
    pages: [
      {
        name: 'Legal 1',
        thumbnailUrl:
          'https://www.relume.io/__assets/61789b489343c8242282a0ae/6426266e49a5eda8f442972a_Legal1.png',
        sections: [
          aSection({
            name: 'Navbar',
            element: aSectionElement('navbar1_component'),
          }),
          aSection({
            name: 'Legal Page Body Section',
            element: aSectionElement('section_header64'),
          }),
          aSection({
            name: 'Footer',
            element: aSectionElement('footer1_component'),
          }),
        ],
      },
    ],
  },
];
